import React from 'react';
import MaterialListItemIcon from '@mui/material/ListItemIcon';
import {styled} from '@mui/material/styles';
import type {ListItemIconProps as MaterialListItemIconProps} from '@mui/material/ListItemIcon';

export type ListItemIconProps = MaterialListItemIconProps;

const StyledListItemIcon = styled(MaterialListItemIcon)(({theme}) => ({
    minWidth: '40px',
    color: theme.tokens.FuelColorGray500
}));

export const ListItemIcon = React.forwardRef<any, ListItemIconProps>(
    (
        {
            children,
            ...props
        },
        ref
    ) => {
        return (
            <StyledListItemIcon
                ref={ref}
                {...props}
            >
                {children}
            </StyledListItemIcon>
        );
    });

ListItemIcon.displayName = 'ListItemIcon';
